export default "__VITE_ASSET__7kL1MDf4__"